import {
  AssignmentInd as AssignIcon,
  Download as DownloadIcon,
  MoreVert as MoreVertIcon,
  Visibility as ViewIcon,
} from "@mui/icons-material";
import { IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";

interface EFaxRowActionsProps {
  onView: () => void;
  onDownload: () => void;
  onAssign: () => void;
}

const EFaxRowActions: React.FC<EFaxRowActionsProps> = ({
  onView,
  onDownload,
  onAssign,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const wrap = (fn: () => void) => () => {
    handleClose();
    fn();
  };

  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={wrap(onView)}>
          <ListItemIcon>
            <ViewIcon fontSize="small" />
          </ListItemIcon>
          View fax
        </MenuItem>
        <MenuItem onClick={wrap(onDownload)}>
          <ListItemIcon>
            <DownloadIcon fontSize="small" />
          </ListItemIcon>
          Download fax
        </MenuItem>
        <MenuItem onClick={wrap(onAssign)}>
          <ListItemIcon>
            <AssignIcon fontSize="small" />
          </ListItemIcon>
          Assign to patient chart
        </MenuItem>
      </Menu>
    </>
  );
};

export default EFaxRowActions;
